import { numberFormat } from '@nike/i18n-core';
import useLocale from './localeHook';

function useFormatPrice({
  currentPrice: finalPrice,
  initialPrice: listPrice,
  currency,
  discountPercentage,
}) {
  const onSale = discountPercentage > 0;
  const { intl, country } = useLocale();
  const isIndia = country.toLowerCase() === 'in';

  const localeForCurrency = (() => {
    switch (country.toLowerCase()) {
      case 'in':
        return 'en-IN';
      case 'au':
        return 'en-AU';
      case 'ca':
        return 'en-CA';
      default:
        return intl;
    }
  })();

  const priceOptions = {
    currency,
    encourageWholeNumbers: !isIndia,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  const finalPriceFormatted =
    finalPrice && numberFormat(localeForCurrency, Number(finalPrice), priceOptions);
  const listPriceFormatted =
    listPrice && numberFormat(localeForCurrency, Number(listPrice), priceOptions);

  let price = isIndia ? `MRP : ${finalPriceFormatted}` : finalPriceFormatted;
  let discountPrice;

  // Required to display original pricing in India if on sale
  if (isIndia && onSale) {
    price = `MRP : ${listPriceFormatted}`;
    discountPrice = finalPriceFormatted;
  }

  return { price, discountPrice };
}

export default useFormatPrice;
